<template>
  <div class="join-us-background">
    <div class="join-us-banner">
      <div class="join-us-container">
        <div class="join-us-banner-title">{{ $t("join.banner") }}</div>
      </div>

      <img class="join-us-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="join-us-container">

     <div class="join-us-content">
       <div class="join-us-content-title">
         <div class="join-us-content-title-text">{{ $t("join.title") }}</div>
       </div>
       <div class="join-us-content-info">
         <p class="join-us-content-info-text">{{ $t("join.joinP1") }}</p>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">{{ $t("join.positionAname") }}</div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">{{ $t("join.positionAtitle") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionAtext1") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionAtext2") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionAtext3") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionAtext4") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionAtext5") }}</div>
         </div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">{{ $t("join.descriptionA") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.descriptionAtext1") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.descriptionAtext2") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.descriptionAtext3") }}</div>
         </div>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">{{ $t("join.positionBname") }}</div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">{{ $t("join.positionBtitle") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionBtext1") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionBtext2") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionBtext3") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionBtext4") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.positionBtext5") }}</div>
         </div>
         <div class="join-us-position-require">
           <div class="join-us-position-title">{{ $t("join.descriptionB") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.descriptionBtext1") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.descriptionBtext2") }}</div>
           <div class="join-us-position-require-text"><i class="fa fa-check-square-o fa-join-us-position"></i>{{ $t("join.descriptionBtext3") }}</div>
         </div>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">{{ $t("join.positionCname") }}</div>
         <div class="join-us-position-require">
           <div class="join-us-position-require-text">{{ $t("join.positionCtext1") }}</div>
           <div class="join-us-position-require-text">{{ $t("join.positionCtext2") }}</div>
           <div class="join-us-position-require-text">{{ $t("join.positionCtext3") }}</div>
           <div class="join-us-position-require-text">{{ $t("join.positionCtext4") }}</div>
         </div>
       </div>
       <div class="join-us-position">
         <div class="join-us-position-name">{{ $t("join.positionDname") }}</div>
         <div class="join-us-position-require">
           <div class="join-us-position-require-text">{{ $t("join.positionDtext1") }}</div>
           <div class="join-us-position-require-text">{{ $t("join.positionDtext2") }}</div>
           <div class="join-us-position-require-text">{{ $t("join.positionDtext3") }}</div>
           <div class="join-us-position-require-text">{{ $t("join.positionDtext4") }}</div>
         </div>
       </div>

       <div class="join-us-position">
         <div class="join-us-position-name">{{ $t("join.positionEname") }}</div>
         <div class="join-us-position-require">
           <div class="join-us-position-require-text">{{ $t("join.positionEtext1") }}：zhaopin@pwmat.com</div>

         </div>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "companyIntroduce"
  }
</script>

<style scoped>
  .join-us-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .join-us-background{
    margin-top: 70px;
  }
  .join-us-banner{
    overflow:hidden;
  }
  .join-us-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .join-us-banner-img{
    min-width:100%;
    height:165px;
  }
  .join-us-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .join-us-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .join-us-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .join-us-content-info{
    margin-top: 50px;
  }
  .join-us-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .join-us-position{
    padding-top: 18px;
  }
  .join-us-position-name{
    color:rgba(73,145,201,1);
    font-size:22px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    line-height:50px;
  }
  .join-us-position-title{
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    line-height:50px;
  }
  .join-us-position-require-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 8px;
  }
  .fa-join-us-position{
    margin-right: 8px;
  }
  @media screen and (max-width:482px) {
    .join-us-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .join-us-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .join-us-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .join-us-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .join-us-container{
      max-width: 1068px;
    }
  }

</style>
